enum ContactModalEnum {
    leaveContactInfo = "cn.leaveContactInfo",
    corporateName = "cn.corporateName",
    contactPerson = "cn.contactPerson",
    contactPhone = "cn.contactPhone",
    contactMailbox = "cn.contactMailbox",
    contactAddress = "cn.contactAddress",
    streetName = "cn.streetName",
    province = "cn.province",
    municipality = "cn.municipality",
    area = "cn.area",
    postalCode = "cn.postalCode",
    businessFormat = "cn.businessFormat",
    isChain = "cn.isChain",
    close = "cn.close",
    submit = "cn.submit",
    pleaseInput = "cn.pleaseInput",
    pleaseSelect = "cn.pleaseSelect",
    pleaseSelectProvince = "cn.pleaseSelectProvince",
    pleaseSelectCity = "cn.pleaseSelectCity",
    pleaseInputPhone = "cn.pleaseInputPhone",
    submitSuccess = "cn.submitSuccess",
    noLabel = "cn.no",
    yesLabel = "cn.yes",
    cafeLabel = "cn.cafe",
    comprehensive = "cn.comprehensive",
    bakingShop = "cn.bakingShop",
    Malatang = "cn.Malatang",
    Hotpot = "cn.Hotpot",
    BBQ = "cn.BBQ",
    ChineseBuffet = "cn.ChineseBuffet",
    WesternStyleBuffet = "cn.WesternStyleBuffet",
    GroupMealsCafeteria = "cn.GroupMealsCafeteria",
    GrandMeal = "cn.GrandMeal",
    Retail = "cn.Retail",



    houseNumber = "cn.houseNumber",
    countryOrRegion = "cn.countryOrRegion",
    understandChannels = "cn.understandChannels",
    openingStatus = "cn.openingStatus",
    whatHelpHopeReceive = "cn.whatHelpHopeReceive",
    understandChannelsSocial = "cn.understandChannelsSocial",
    understandChannelsSearch = "cn.understandChannelsSearch",
    understandChannelsSeeBusinessRes = "cn.understandChannelsSeeBusinessRes",
    understandChannelsRecommendByFriend = "cn.understandChannelsRecommendByFriend",
    contactPrepareProgress = "cn.contactPrepareProgress",
    contactInBusiness = "cn.contactInBusiness",
    contactOther = "cn.contactOther",
}

export default ContactModalEnum;